// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-table-swap-dialog__backdrop {
  z-index: 1500;
  align-items: stretch;
  justify-content: center;
  padding: 8px;
  padding-bottom: var(--lt-coach-bar-reserve, calc(68px + env(safe-area-inset-bottom)));
  box-sizing: border-box;
}

/* Above elevated seating editor opened from session results. */
.lt-table-swap-dialog__backdrop--elevated {
  z-index: 16200;
  padding-bottom: max(8px, env(safe-area-inset-bottom, 0px));
}

/* Match table-setup dialog width so cards share the same footprint. */
.lt-table-swap-dialog.lt-table-wizard {
  position: relative;
  color-scheme: dark;
  width: min(560px, 100%);
  max-width: 100%;
  height: calc(
    var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 16px -
      env(safe-area-inset-top, 0px)
  );
  max-height: calc(
    var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 16px -
      env(safe-area-inset-top, 0px)
  );
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 14px;
}

.lt-table-swap-dialog .lt-coach-table {
  background: var(--lt-card-bg, #1e293b);
  border-color: rgba(255, 255, 255, 0.12);
  color: var(--lt-card-fg, #f8fafc);
}

.lt-table-swap-dialog .lt-coach-table__player--btn {
  background-color: var(--lt-player-bg, #334155);
  color: var(--lt-card-fg, #f8fafc);
}

.lt-table-swap-dialog .lt-coach-table__player--btn .lt-coach-table__name {
  color: inherit;
}

.lt-table-swap-dialog .lt-coach-table__player--swappable {
  border-width: 2px;
  border-style: solid;
  border-color: rgba(125, 211, 252, 0.75) !important;
}

.lt-table-swap-dialog .lt-coach-table__player--selected,
.lt-table-swap-dialog .lt-coach-table__list-row.is-selected {
  border-width: 2px !important;
  border-style: solid !important;
  border-color: var(--lt-brand, #0877bc) !important;
  box-shadow:
    0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.5),
    0 0 14px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3) !important;
  z-index: 1;
}

.lt-table-swap-dialog .lt-coach-table__player--target:not([aria-disabled="true"]),
.lt-table-swap-dialog .lt-coach-table__list-row.is-target {
  border-width: 2px !important;
  border-style: dashed !important;
  border-color: #f59e0b !important;
  box-shadow:
    0 0 0 2px rgba(245, 158, 11, 0.55),
    inset 0 0 0 1px rgba(253, 230, 138, 0.2) !important;
  z-index: 1;
}

.lt-table-swap-dialog .lt-coach-table__list-row.is-interactive:not(.is-selected):not(.is-target) {
  border-width: 2px;
  border-color: rgba(125, 211, 252, 0.65);
}

.light-mode .lt-table-swap-dialog.lt-table-wizard {
  background: linear-gradient(
    165deg,
    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 10%, #f8fafc) 0%,
    #ffffff 55%,
    #f1f5f9 100%
  );
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, #cbd5e1);
  color: #0f172a;
}

.light-mode .lt-table-swap-dialog .lt-table-wizard__header h2,
.light-mode .lt-table-swap-dialog .lt-table-wizard__subtitle,
.light-mode .lt-table-swap-dialog__status-text {
  color: #0f172a;
}

.light-mode .lt-table-swap-dialog .lt-coach-table {
  border-color: color-mix(in srgb, var(--lt-table-accent, #46528b) 40%, #cbd5e1);
}

.light-mode .lt-table-swap-dialog__mode-btn {
  background: rgba(15, 23, 42, 0.04);
  border-color: rgba(15, 23, 42, 0.14);
  color: #0f172a;
}

.light-mode .lt-table-swap-dialog__status {
  background: rgba(248, 250, 252, 0.95);
  border-top-color: rgba(15, 23, 42, 0.1);
  color: #334155;
}

.light-mode .lt-table-swap-dialog__status--picking {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);
  color: #0f172a;
}

.light-mode .lt-table-swap-dialog__source-cancel {
  background: rgba(15, 23, 42, 0.05);
  border-color: rgba(15, 23, 42, 0.14);
  color: #0f172a;
}

.light-mode .lt-table-swap-dialog__edge {
  background: rgba(248, 250, 252, 0.9);
  color: #0f172a;
}

.lt-table-swap-dialog__header {
  align-items: flex-start;
  flex-shrink: 0;
  padding: 8px 12px 6px;
}

.lt-table-swap-dialog__header-tools {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.lt-table-swap-dialog__mode-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.06);
  color: #f8fafc;
  cursor: pointer;
}

.lt-table-swap-dialog__mode-btn.is-active {
  border-color: rgba(245, 158, 11, 0.7);
  background: rgba(245, 158, 11, 0.22);
  color: #fde68a;
}

.lt-table-swap-dialog__body {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  padding: 4px 10px 6px;
  box-sizing: border-box;
}

.lt-table-swap-dialog__pager {
  position: relative;
  display: flex;
  align-items: stretch;
  min-height: 0;
  height: 100%;
}

.lt-table-swap-dialog__pages {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.lt-table-swap-dialog__pages::-webkit-scrollbar {
  display: none;
}

.lt-table-swap-dialog__page {
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  padding: 0 28px;
  box-sizing: border-box;
  overflow: hidden;
}

.lt-table-swap-dialog__tables-grid {
  display: grid;
  grid-template-columns: repeat(var(--lt-tables-cols, 1), minmax(0, 1fr));
  /* Size rows to card content so dual tables stay compact */
  grid-template-rows: repeat(var(--lt-tables-rows, 5), auto);
  gap: 5px;
  height: auto;
  min-height: 0;
  align-content: start;
}

.lt-table-swap-dialog__tables-grid > .lt-coach-table {
  --lt-table-accent: var(--lt-brand, var(--brand-primary, #0877bc));
  padding: 5px 7px;
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, rgba(255, 255, 255, 0.12));
}

.lt-table-swap-dialog__card {
  min-height: 0;
  height: auto;
  max-width: 100%;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.lt-table-swap-dialog__card.lt-coach-table--multi {
  height: auto;
  min-height: 0;
  justify-content: flex-start;
  padding: 6px 8px;
  overflow: visible;
}

.lt-table-swap-dialog__card:not(.lt-coach-table--multi) {
  padding: 5px 7px;
}

.lt-table-swap-dialog__card.lt-coach-table--multi .lt-coach-table__list--halves {
  flex: 0 0 auto;
}

/* Move mode only: destination is a whole table. Swap highlights stay on player cells. */
.lt-table-swap-dialog__card--target-table {
  border-color: rgba(245, 158, 11, 0.75) !important;
  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.35);
}

.lt-table-swap-dialog__edge {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  width: 28px;
  height: 56px;
  border: none;
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.72);
  color: #f8fafc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.lt-table-swap-dialog__edge--prev {
  left: 0;
}

.lt-table-swap-dialog__edge--next {
  right: 0;
}

.lt-table-swap-dialog__edge:disabled {
  opacity: 0.25;
  cursor: default;
}

.lt-table-swap-dialog__status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  flex-shrink: 0;
  min-height: 48px;
  margin: 0;
  padding: 8px 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(15, 23, 42, 0.92);
  color: rgba(248, 250, 252, 0.82);
}

.lt-table-swap-dialog__status--picking {
  background: rgba(8, 119, 188, 0.18);
  color: #e0f2fe;
}

.lt-table-swap-dialog__status-text {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.82rem;
  font-weight: 650;
  line-height: 1.3;
}

.lt-table-swap-dialog__source-cancel {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.08);
  color: #f8fafc;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
}

.lt-table-swap-dialog__source-cancel:hover {
  background: rgba(255, 255, 255, 0.14);
}

.lt-table-swap-dialog__stations {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0 12px 8px;
  flex-shrink: 0;
}

.lt-table-swap-dialog__station-btn {
  padding: 5px 10px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(15, 23, 42, 0.35);
  color: rgba(248, 250, 252, 0.9);
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
}

.lt-table-swap-dialog__station-btn.is-selected {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, transparent);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 32%, transparent);
  color: #fff;
}

.lt-table-swap-dialog__station-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.light-mode .lt-table-swap-dialog__station-btn {
  background: #fff;
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);
  color: #0f172a;
}

/* Same breakpoints as table-setup dialog. */
@media (min-width: 720px) {
  .lt-table-swap-dialog.lt-table-wizard {
    width: min(720px, 100%);
  }
}

@media (min-width: 1100px) {
  .lt-table-swap-dialog.lt-table-wizard {
    width: min(920px, 100%);
  }
}

@media (max-width: 520px) {
  .lt-table-swap-dialog.lt-table-wizard {
    width: 100%;
    border-radius: 12px;
  }

  .lt-table-swap-dialog__page {
    padding: 0 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingTableSwapDialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,qFAAqF;EACrF,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,cAAc;EACd,0DAA0D;AAC5D;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf;;;GAGC;EACD;;;GAGC;EACD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,8CAA8C;EAC9C,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;;EAEE,4BAA4B;EAC5B,8BAA8B;EAC9B,iDAAiD;EACjD;;wEAEsE;EACtE,UAAU;AACZ;;AAEA;;EAEE,4BAA4B;EAC5B,+BAA+B;EAC/B,gCAAgC;EAChC;;uDAEqD;EACrD,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE;;;;;GAKC;EACD,uEAAuE;EACvE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,kEAAkE;EAClE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uEAAuE;EACvE,0DAA0D;EAC1D,0DAA0D;EAC1D,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iEAAiE;EACjE,gBAAgB;EAChB,yFAAyF;AAC3F;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,wFAAwF;AACxF;EACE,iDAAiD;EACjD,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,8CAA8C;EAC9C,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2EAA2E;EAC3E,yEAAyE;EACzE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uEAAuE;EACvE,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".lt-table-swap-dialog__backdrop {\n  z-index: 1500;\n  align-items: stretch;\n  justify-content: center;\n  padding: 8px;\n  padding-bottom: var(--lt-coach-bar-reserve, calc(68px + env(safe-area-inset-bottom)));\n  box-sizing: border-box;\n}\n\n/* Above elevated seating editor opened from session results. */\n.lt-table-swap-dialog__backdrop--elevated {\n  z-index: 16200;\n  padding-bottom: max(8px, env(safe-area-inset-bottom, 0px));\n}\n\n/* Match table-setup dialog width so cards share the same footprint. */\n.lt-table-swap-dialog.lt-table-wizard {\n  position: relative;\n  color-scheme: dark;\n  width: min(560px, 100%);\n  max-width: 100%;\n  height: calc(\n    var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 16px -\n      env(safe-area-inset-top, 0px)\n  );\n  max-height: calc(\n    var(--lt-vvh, 100dvh) - var(--lt-coach-bar-reserve, 68px) - 16px -\n      env(safe-area-inset-top, 0px)\n  );\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-sizing: border-box;\n  border-radius: 14px;\n}\n\n.lt-table-swap-dialog .lt-coach-table {\n  background: var(--lt-card-bg, #1e293b);\n  border-color: rgba(255, 255, 255, 0.12);\n  color: var(--lt-card-fg, #f8fafc);\n}\n\n.lt-table-swap-dialog .lt-coach-table__player--btn {\n  background-color: var(--lt-player-bg, #334155);\n  color: var(--lt-card-fg, #f8fafc);\n}\n\n.lt-table-swap-dialog .lt-coach-table__player--btn .lt-coach-table__name {\n  color: inherit;\n}\n\n.lt-table-swap-dialog .lt-coach-table__player--swappable {\n  border-width: 2px;\n  border-style: solid;\n  border-color: rgba(125, 211, 252, 0.75) !important;\n}\n\n.lt-table-swap-dialog .lt-coach-table__player--selected,\n.lt-table-swap-dialog .lt-coach-table__list-row.is-selected {\n  border-width: 2px !important;\n  border-style: solid !important;\n  border-color: var(--lt-brand, #0877bc) !important;\n  box-shadow:\n    0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.5),\n    0 0 14px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3) !important;\n  z-index: 1;\n}\n\n.lt-table-swap-dialog .lt-coach-table__player--target:not([aria-disabled=\"true\"]),\n.lt-table-swap-dialog .lt-coach-table__list-row.is-target {\n  border-width: 2px !important;\n  border-style: dashed !important;\n  border-color: #f59e0b !important;\n  box-shadow:\n    0 0 0 2px rgba(245, 158, 11, 0.55),\n    inset 0 0 0 1px rgba(253, 230, 138, 0.2) !important;\n  z-index: 1;\n}\n\n.lt-table-swap-dialog .lt-coach-table__list-row.is-interactive:not(.is-selected):not(.is-target) {\n  border-width: 2px;\n  border-color: rgba(125, 211, 252, 0.65);\n}\n\n.light-mode .lt-table-swap-dialog.lt-table-wizard {\n  background: linear-gradient(\n    165deg,\n    color-mix(in srgb, var(--lt-brand-secondary, #46528b) 10%, #f8fafc) 0%,\n    #ffffff 55%,\n    #f1f5f9 100%\n  );\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 22%, #cbd5e1);\n  color: #0f172a;\n}\n\n.light-mode .lt-table-swap-dialog .lt-table-wizard__header h2,\n.light-mode .lt-table-swap-dialog .lt-table-wizard__subtitle,\n.light-mode .lt-table-swap-dialog__status-text {\n  color: #0f172a;\n}\n\n.light-mode .lt-table-swap-dialog .lt-coach-table {\n  border-color: color-mix(in srgb, var(--lt-table-accent, #46528b) 40%, #cbd5e1);\n}\n\n.light-mode .lt-table-swap-dialog__mode-btn {\n  background: rgba(15, 23, 42, 0.04);\n  border-color: rgba(15, 23, 42, 0.14);\n  color: #0f172a;\n}\n\n.light-mode .lt-table-swap-dialog__status {\n  background: rgba(248, 250, 252, 0.95);\n  border-top-color: rgba(15, 23, 42, 0.1);\n  color: #334155;\n}\n\n.light-mode .lt-table-swap-dialog__status--picking {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);\n  color: #0f172a;\n}\n\n.light-mode .lt-table-swap-dialog__source-cancel {\n  background: rgba(15, 23, 42, 0.05);\n  border-color: rgba(15, 23, 42, 0.14);\n  color: #0f172a;\n}\n\n.light-mode .lt-table-swap-dialog__edge {\n  background: rgba(248, 250, 252, 0.9);\n  color: #0f172a;\n}\n\n.lt-table-swap-dialog__header {\n  align-items: flex-start;\n  flex-shrink: 0;\n  padding: 8px 12px 6px;\n}\n\n.lt-table-swap-dialog__header-tools {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.lt-table-swap-dialog__mode-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.06);\n  color: #f8fafc;\n  cursor: pointer;\n}\n\n.lt-table-swap-dialog__mode-btn.is-active {\n  border-color: rgba(245, 158, 11, 0.7);\n  background: rgba(245, 158, 11, 0.22);\n  color: #fde68a;\n}\n\n.lt-table-swap-dialog__body {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  padding: 4px 10px 6px;\n  box-sizing: border-box;\n}\n\n.lt-table-swap-dialog__pager {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  min-height: 0;\n  height: 100%;\n}\n\n.lt-table-swap-dialog__pages {\n  flex: 1 1 auto;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scroll-snap-type: x mandatory;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.lt-table-swap-dialog__pages::-webkit-scrollbar {\n  display: none;\n}\n\n.lt-table-swap-dialog__page {\n  flex: 0 0 100%;\n  width: 100%;\n  height: 100%;\n  scroll-snap-align: start;\n  scroll-snap-stop: always;\n  padding: 0 28px;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.lt-table-swap-dialog__tables-grid {\n  display: grid;\n  grid-template-columns: repeat(var(--lt-tables-cols, 1), minmax(0, 1fr));\n  /* Size rows to card content so dual tables stay compact */\n  grid-template-rows: repeat(var(--lt-tables-rows, 5), auto);\n  gap: 5px;\n  height: auto;\n  min-height: 0;\n  align-content: start;\n}\n\n.lt-table-swap-dialog__tables-grid > .lt-coach-table {\n  --lt-table-accent: var(--lt-brand, var(--brand-primary, #0877bc));\n  padding: 5px 7px;\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, rgba(255, 255, 255, 0.12));\n}\n\n.lt-table-swap-dialog__card {\n  min-height: 0;\n  height: auto;\n  max-width: 100%;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.lt-table-swap-dialog__card.lt-coach-table--multi {\n  height: auto;\n  min-height: 0;\n  justify-content: flex-start;\n  padding: 6px 8px;\n  overflow: visible;\n}\n\n.lt-table-swap-dialog__card:not(.lt-coach-table--multi) {\n  padding: 5px 7px;\n}\n\n.lt-table-swap-dialog__card.lt-coach-table--multi .lt-coach-table__list--halves {\n  flex: 0 0 auto;\n}\n\n/* Move mode only: destination is a whole table. Swap highlights stay on player cells. */\n.lt-table-swap-dialog__card--target-table {\n  border-color: rgba(245, 158, 11, 0.75) !important;\n  box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.35);\n}\n\n.lt-table-swap-dialog__edge {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 2;\n  width: 28px;\n  height: 56px;\n  border: none;\n  border-radius: 10px;\n  background: rgba(15, 23, 42, 0.72);\n  color: #f8fafc;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.lt-table-swap-dialog__edge--prev {\n  left: 0;\n}\n\n.lt-table-swap-dialog__edge--next {\n  right: 0;\n}\n\n.lt-table-swap-dialog__edge:disabled {\n  opacity: 0.25;\n  cursor: default;\n}\n\n.lt-table-swap-dialog__status {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  min-height: 48px;\n  margin: 0;\n  padding: 8px 14px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(15, 23, 42, 0.92);\n  color: rgba(248, 250, 252, 0.82);\n}\n\n.lt-table-swap-dialog__status--picking {\n  background: rgba(8, 119, 188, 0.18);\n  color: #e0f2fe;\n}\n\n.lt-table-swap-dialog__status-text {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.82rem;\n  font-weight: 650;\n  line-height: 1.3;\n}\n\n.lt-table-swap-dialog__source-cancel {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.08);\n  color: #f8fafc;\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.lt-table-swap-dialog__source-cancel:hover {\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.lt-table-swap-dialog__stations {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 0 12px 8px;\n  flex-shrink: 0;\n}\n\n.lt-table-swap-dialog__station-btn {\n  padding: 5px 10px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(15, 23, 42, 0.35);\n  color: rgba(248, 250, 252, 0.9);\n  font-size: 0.72rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.lt-table-swap-dialog__station-btn.is-selected {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 70%, transparent);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 32%, transparent);\n  color: #fff;\n}\n\n.lt-table-swap-dialog__station-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.light-mode .lt-table-swap-dialog__station-btn {\n  background: #fff;\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);\n  color: #0f172a;\n}\n\n/* Same breakpoints as table-setup dialog. */\n@media (min-width: 720px) {\n  .lt-table-swap-dialog.lt-table-wizard {\n    width: min(720px, 100%);\n  }\n}\n\n@media (min-width: 1100px) {\n  .lt-table-swap-dialog.lt-table-wizard {\n    width: min(920px, 100%);\n  }\n}\n\n@media (max-width: 520px) {\n  .lt-table-swap-dialog.lt-table-wizard {\n    width: 100%;\n    border-radius: 12px;\n  }\n\n  .lt-table-swap-dialog__page {\n    padding: 0 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
